export default __webpack_public_path__ + "static/media/illustration-study-2-w@3x.6c523fe0.webp";